import React from 'react';
import './styles.scss';
import { useTranslation } from 'react-i18next';
import Icons from 'core/data/constants/Icons';
import Map from 'core/components/map';
import Images from 'core/data/constants/Images';
import { motion } from "framer-motion";
import MotionDiv from 'core/components/Motion';
import { useMediaQuery } from "react-responsive";

export default function Home() {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ maxWidth: 600 });
  return (
    <div className="mainHome pageBody">
      <MotionDiv className="banner"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.2 }}
      >
        <img
          src={Images.HomeBannerImage}
          alt="bannerImage"
        />
        <div className="bannerText">
          <h1>{t('ironing_sara')}</h1>
          <p>{t('home_page_title_description')}</p>
        </div>
      </MotionDiv>
      <div className="aboutUsSection">
        <motion.img
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: false, amount: 0.4 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          src={Images.HomeAboutUsImage}
          alt="Engomadaria"
        />

        <MotionDiv viewport={{ once: false, amount: 0.3 }}>
          <h3>{t('home_page_about_us')}</h3>
          <p>{t('home_page_about_us_description')}</p>
          <div>
            <p>{t('home_page_about_us_description_list_title')}</p>
            <ul>
              {(
                t('home_page_about_us_description_list', {
                  returnObjects: true,
                }) as string[]
              ).map(createList)}
            </ul>
          </div>
        </MotionDiv>
      </div>
      <MotionDiv id="info"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: false, amount: isMobile ? 0.1 : 0.3 }}
      >
        <MotionDiv id="homeInfoMap"
          initial={{ opacity: 0, x: -40 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <h1>{t('home_page_where_finds_us')}</h1>
          <Map />
        </MotionDiv>

        <MotionDiv id="infoSchedule"
          initial={{ opacity: 0, x: isMobile ? 40 : 0, y: isMobile ? 0 : 40 }}
          whileInView={{ opacity: 1, x: 0, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <h1>{t('default_schedule')}</h1>
          <p className='subTitle'>{t('home_page_schedule_monday_to_friday')}</p>
          <p>{t('home_page_schedule_monday_to_friday_time')}</p>
          <p className='subTitle'>{t('home_page_schedule_saturday')}</p>
          <p>{t('home_page_schedule_saturday_time')}</p>
          <p className='subTitle'>{t('home_page_schedule_sunday')}</p>
          <p>{t('home_page_schedule_sunday_time')}</p>
        </MotionDiv>
        <MotionDiv id="contactUs"
          initial={{ opacity: 0, x: isMobile ? -40 : 40 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <h1>{t('home_page_dont_hesitate_contact_us')}</h1>
          <div id="homeInfoContactUsDescription">
            {descriptionWithIcon(Icons.Email(), t('home_page_write_us'), t('default_email_address'))}
            {descriptionWithIcon(Icons.CellPhone(), t('home_page_call_us'), t('home_page_call_us_description'))}
            {descriptionWithIcon(Icons.Location(), t('home_page_visit_us'), t('default_shop_address'))}
            {followUs(Icons.FollowUs(), t('home_page_follow_us'), t('default_facebook_link'))}
          </div>
        </MotionDiv>
      </MotionDiv>
    </div>
  );
}

function createList(title: string) {
  return (
    <li key={title}>
      {Icons.CheckMarkCircle()}
      {title}
    </li>
  );
}

function descriptionWithIcon(icon: React.JSX.Element, title: string, description: string) {
  return (
    <div>
      {icon}
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  );
}

function followUs(icon: React.JSX.Element, title: string, url: string) {
  return (
    <div>
      {icon}
      <h4>{title}</h4>
      <a id="followUsIcos" href={url} target="_blank" rel="noopener noreferrer">
        {Icons.Facebook()}
      </a>
    </div>
  );
}
